'use client';

import { useEffect, useMemo, useState } from 'react';
import Image from 'next/image';
import s from './styles.module.scss';

export const DailySchedule = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [vw, setVw] = useState<number | null>(null);

    const toggleOpen = () => setIsOpen((prev) => !prev);

    useEffect(() => {
        const setWidth = () => setVw(window.innerWidth);
        setWidth();
        window.addEventListener('resize', setWidth);
        return () => window.removeEventListener('resize', setWidth);
    }, []);

    const isMobile = (vw ?? 10000) <= 790;

    // Розклад розбитий на дві частини (для десктопу)
    const leftPart = useMemo(
        () =>
            [
                ['8:00', 'підйом'],
                ['8:45', 'зарядка'],
                ['9:15', 'сніданок'],
                ['10:00', 'англійська'],
                ['11:45', 'перерва'],
                ['12:00', 'англійська'],
                ['13:30', 'обід'],
                ['14:00', 'басейн/спорт'],
                ['15:00', 'підготовка до концерту'],
                ['17:00', 'перекус'],
            ] as const,
        []
    );

    const rightPart = useMemo(
        () =>
            [
                ['17:15', 'концерт'],
                ['18:00', 'Gadget Time'],
                ['19:00', 'обід'],
                ['19:30', 'ігри/майстер-класи'],
                ['20:30', 'підготовка до дискотеки/фільм'],
                ['21:00', 'дискотека/фільм'],
                ['22:30', 'обговорення'],
                ['23:00', 'підготовка до сну'],
                ['23:30', 'відбій'],
            ] as const,
        []
    );

    const allDay = useMemo(() => [...leftPart, ...rightPart], [leftPart, rightPart]);

    return (
        <section className={s.root}>
            <div className={s.container} onClick={toggleOpen} style={{ cursor: 'pointer' }}>
                <div className={s.title}>
                    <p className={s.title_first}>Так виглядає твій стандартний</p>
                    <p className={s.title_second}>розклад дня:</p>
                </div>
                <button
                    className={s.arrowBtn}
                    type="button"
                    tabIndex={-1}
                    aria-label="Toggle schedule"
                >
                    <Image
                        className={isOpen ? `${s.arrowIcon} ${s.arrowIcon_open}` : s.arrowIcon}
                        src="/icons/daily-arrow.svg"
                        alt=""
                        width={40}
                        height={15}
                    />
                </button>
            </div>

            <div className={isOpen ? `${s.schedule} ${s.schedule_open}` : s.schedule}>
                {/* Мобілка: один список */}
                {isMobile ? (
                    <div className={s.rozclad}>
                        <ul>
                            {allDay.map(([time, label]) => (
                                <li key={time + label}>
                                    <div>{time}</div> {label}
                                </li>
                            ))}
                        </ul>

                        <div className={s.images}>
                            <Image src="/images/day1.png" alt="" width={190.03} height={227.5} />
                            <Image src="/images/day2.png" alt="" width={221.96} height={287.89} />
                            <Image src="/images/day3.png" alt="" width={127} height={148.88} />
                        </div>
                    </div>
                ) : (
                    // Десктоп/планшет: дві колонки, між ними картинки
                    <div className={s.grid}>
                        <ul>
                            {leftPart.map(([time, label]) => (
                                <li key={time + label}>
                                    <div>{time}</div> {label}
                                </li>
                            ))}
                        </ul>

                        <div className={s.images}>
                            <Image src="/images/day1.png" alt="" width={190.03} height={227.5} />
                            <Image src="/images/day2.png" alt="" width={221.96} height={287.89} />
                        </div>

                        <ul>
                            {rightPart.map(([time, label]) => (
                                <li key={time + label}>
                                    <div>{time}</div> {label}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </section>
    );
};
